"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedSignWallet = void 0;
// A wallet that caches signed messages to avoid multiple calls to the wallet
class CachedSignWallet {
    constructor(wallet) {
        this.wallet = wallet;
        this.cache = {};
    }
    async signMessage(message) {
        const key = message.toString();
        try {
            if (!this.cache[key]) {
                this.cache[key] = this.wallet.signMessage(message);
            }
            return (await this.cache[key]);
        }
        catch (error) {
            // clear the cache if there's an error
            delete this.cache[key];
            throw error;
        }
    }
}
exports.CachedSignWallet = CachedSignWallet;
